<template>
  <div class="w-100">
    <b-modal size="lg" v-model="openModel" @ok="saveDiscountCode">
      <template v-slot:modal-title>
        <span>{{method == "update" ? "修改" : "新增"}}代號</span>
      </template>
      <div class="w-100">
        <table class="table table-sm table-bordered discount__code__box">
          <tbody>
            <tr>
              <td class="code__box__title">折扣代號</td>
              <td>
                <b-input-group>
                  <b-form-input v-model="discountCode.code"></b-form-input>
                  <b-input-group-append>
                    <button class="btn btn-sm btn-primary" @click="autoDiscountCode()">自動</button>
                  </b-input-group-append>
                </b-input-group>
                <ul class="code__box__example__list">
                  <li>
                    <small>（最少6碼、最多10碼 不分大小寫）</small>
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <td class="code__box__title">使用狀態</td>
              <td>
                <b-form-checkbox v-model="discountCode.useState" value="1" unchecked-value="0">
                  {{discountCode.useState ? "目前使用中" : "目前停用中"}}</b-form-checkbox>
              </td>
            </tr>
            <tr>
              <td class="code__box__title">折價方式</td>
              <td>
                <div class="w-100">
                  <div class="d-flex align-items-center mb-2">
                    <span style="width: 60px">折價條件</span>
                    <div style="min-width: 100px">
                      <select class="form-control" v-model="discountCode.limitModel"
                        @change="changeLimitAndMethod('limit')">
                        <option value="buyCount">購買數量</option>
                        <option value="buyMoney">購買額度</option>
                      </select>
                    </div>
                    <span style="width: 60px">折價方式</span>
                    <div style="width: 100px">
                      <select class="form-control" v-model="discountCode.discountModel"
                        @change="changeLimitAndMethod('model')">
                        <option value="percentage">折扣</option>
                        <option value="realNumber">折現</option>
                      </select>
                    </div>
                  </div>
                  <div class="d-flex align-items-center">
                    <div class="d-flex align-items-center">
                      <span class="text-nowrap">購物滿</span>
                      <input class="form-control" v-model="discountCode.limitValue" />
                      <span v-if="discountCode.limitModel == 'buyMoney'">元</span>
                      <span v-if="discountCode.limitModel == 'buyCount'">件</span>
                    </div>

                    <div class="d-flex align-items-center ml-2"
                      v-if="discountCode.discountModel=='percentage'">
                      <span>打</span>
                      <b-form-select style="width: 140px" :options="discountRange"
                        v-model="discountCode.discountValue">
                      </b-form-select>
                      <span>折</span>
                    </div>

                    <div class="d-flex align-items-center ml-2"
                      v-if="discountCode.discountModel=='realNumber'">
                      <span>折</span>
                      <input type="number" class="form-control" style="width: 140px"
                        v-model="discountCode.discountValue">
                      <span>元</span>
                    </div>
                  </div>


                  <ul class="code__box__example__list">
                    <li>
                      <small>
                        若無限制低銷，
                        <u class="text-danger">購物滿</u>
                        請填入數值
                        <strong class="text-danger">0</strong>
                      </small>
                    </li>
                  </ul>

                </div>
              </td>
            </tr>
            <tr>
              <td class="code__box__title">可用數量</td>
              <td>
                <b-form-input class="w-25" type="number" v-model="discountCode.count">
                </b-form-input>
              </td>
            </tr>

            <tr>
              <td class="code__box__title">使用期間</td>
              <td>
                <div class="d-flex align-items-center">
                  <b-form-datepicker label-no-date-selected="請選擇起始日" size="sm"
                    v-model="discountCode.time.startTime">
                  </b-form-datepicker>
                  <span> ~ </span>
                  <b-form-datepicker label-no-date-selected="請選擇結束日" size="sm"
                    v-model="discountCode.time.endTime">
                  </b-form-datepicker>
                </div>
              </td>
            </tr>
            <tr>
              <td class="code__box__title">備註</td>
              <td>
                <b-form-textarea v-model="discountCode.remark"></b-form-textarea> 
              </td>
            </tr>
          </tbody>
        </table>

      </div>
      <template v-slot:modal-footer="{ok, close}">
        <div class="d-flex align-items-center justify-content-end">
          <button class="btn btn-sm btn-primary" @click="ok($event)">儲存</button>
          <button class="btn btn-sm btn-danger ml-2" @click="close()">取消</button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import ctrl from "./discountCode.js"
  export default ctrl;

</script>

<style lang="scss">
  .discount__code__box {
    .code__box__title {
      background-color: rgb(197, 197, 197);
      text-align: center;
      vertical-align: middle;
    }

    .code__box__example__list {
      padding: 0 0 0 20px;
      margin: 0;
    }
  }

</style>
